import React from "react";
import { useNavigate } from "react-router-dom";
import LandingHeader from "./header";

 
const LandingSearchHeader = ({search}) =>{
    const navigate = useNavigate();


    const handleSubmitNavigation = (search) =>{
        console.log("search head", search)
        navigate(`/search/${search}`);
    }
    return(
        <header>
            <LandingHeader prompt = { handleSubmitNavigation } search={search}/>
        </header>
    )
}

export default LandingSearchHeader